import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMugHot, faClock, faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";

export default function BreakModal({ isOpen, onClose, onSuccess }) {
    const [active, setActive] = useState(false);
    const [time, setTime] = useState(15);
    const [autoOff, setAutoOff] = useState(true);
    const [message, setMessage] = useState("Trwa przerwa kawowa. Wracamy za chwilę!");
    const [customTime, setCustomTime] = useState("");
    const [loading, setLoading] = useState(false);

    const secretId = localStorage.getItem("secretId");
    const API = "https://api18081113.queroapp.pl";

    // Load current state on open
    useEffect(() => {
        if (isOpen && secretId) {
            // Fetch current status via get-surveys (piggyback) or just rely on local knowing? 
            // Ideally we fetch. Using get-surveys for now.
            fetch(`${API}/get-surveys/${secretId}`)
                .then(r => r.json())
                .then(d => {
                    if (d.break) {
                        setActive(!!d.break.break_active);
                        if (d.break.break_message) setMessage(d.break.break_message);
                        // Time logic is tricky because we store end time, not duration.
                        // But for modal we usually reset duration or calculate remaining.
                        // Let's just default to 15 unless we want to show countdown.
                    }
                })
                .catch(console.error);
        }
    }, [isOpen, secretId]);

    if (!isOpen) return null;

    const handleSave = async () => {
        setLoading(true);
        const timeToSend = autoOff ? (customTime ? parseInt(customTime) : time) : 0;

        try {
            await fetch(`${API}/update-break`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    secretId,
                    active: true, // If we are saving, we enable it
                    time: timeToSend,
                    message
                })
            });
            setActive(true);
            if (onSuccess) onSuccess();
            onClose();
        } catch (e) {
            console.error(e);
            alert("Błąd zapisu przerwy");
        } finally {
            setLoading(false);
        }
    };

    const handleStop = async () => {
        setLoading(true);
        try {
            await fetch(`${API}/update-break`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    secretId,
                    active: false
                })
            });
            setActive(false);
            if (onSuccess) onSuccess();
            onClose();
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-75 d-flex justify-content-center align-items-center" style={{ zIndex: 10000 }}>
            <div className="bg-white rounded-4 p-4 shadow-lg w-100 mx-3" style={{ maxWidth: 450 }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="m-0 fw-bold text-dark d-flex align-items-center gap-2">
                        <FontAwesomeIcon icon={faMugHot} className="text-primary" />
                        Zarządzanie przerwą
                    </h4>
                    <button onClick={onClose} className="btn-close"></button>
                </div>

                <div className="mb-4">
                    <div className="form-check form-switch mb-2">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="autoOffSwitch"
                            checked={autoOff}
                            onChange={e => setAutoOff(e.target.checked)}
                        />
                        <label className="form-check-label small fw-bold text-secondary" htmlFor="autoOffSwitch">
                            Wyłącz automatycznie po czasie
                        </label>
                    </div>

                    {autoOff && (
                        <div className="animate-fade-in">
                            <label className="form-label text-secondary small fw-bold">Czas trwania (minuty)</label>
                            <div className="d-flex gap-2 mb-2 flex-wrap">
                                {[5, 10, 15, 30, 45, 60].map(m => (
                                    <button
                                        key={m}
                                        onClick={() => { setTime(m); setCustomTime(""); }}
                                        className={`btn btn-sm fw-bold rounded-pill px-3 ${time === m && !customTime ? 'btn-primary' : 'btn-light text-secondary'}`}
                                    >
                                        {m}m
                                    </button>
                                ))}
                            </div>
                            <div className="input-group input-group-sm">
                                <input
                                    type="number"
                                    className="form-control bg-light border-0"
                                    placeholder="Własny czas (min)"
                                    value={customTime}
                                    onChange={e => { setCustomTime(e.target.value); if (e.target.value) setTime(0); }}
                                />
                            </div>
                        </div>
                    )}
                </div>

                <div className="mb-4">
                    <label className="form-label text-secondary small fw-bold">Wiadomość dla uczestników</label>
                    <textarea
                        className="form-control bg-light border-0 rounded-3 p-3"
                        rows="3"
                        value={message}
                        onChange={e => setMessage(e.target.value)}
                    ></textarea>
                </div>

                <div className="d-flex flex-column gap-3">
                    {active ? (
                        <button
                            onClick={handleStop}
                            disabled={loading}
                            className="btn btn-danger w-100 py-3 rounded-4 fw-bold shadow-sm"
                            style={{ fontSize: '1.2rem' }}
                        >
                            <FontAwesomeIcon icon={faTimes} className="me-2" />
                            ZAKOŃCZ PRZERWĘ - WRÓĆ DO EVENTU
                        </button>
                    ) : (
                        <button
                            onClick={handleSave}
                            disabled={loading}
                            className="btn btn-primary w-100 py-3 rounded-4 fw-bold shadow-sm"
                            style={{ fontSize: '1.2rem' }}
                        >
                            <FontAwesomeIcon icon={faCheck} className="me-2" />
                            {autoOff ? `URUCHOM PRZERWĘ (${customTime || time} min)` : 'URUCHOM PRZERWĘ (BEZ LIMITU)'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}
